import "./ScaffoldingInMarlow.module.css";
import Header from "@/reusable_sections/Header";
import HeroMarlow from "./sections/HeroMarlow";
import MarlowIntro from "./sections/MarlowIntro";
import LocalServices from "./sections/LocalServices";
import MarlowAccess from "./sections/MarlowAccess";
import Faq from "./sections/Faq";
import QuoteCta from "./sections/QuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInMarlowPage() {
  return <div>
      <Header />
      <HeroMarlow />
      <MarlowIntro />
      <LocalServices />
      <MarlowAccess />
      <Faq />
      <QuoteCta />
      <Footer />
    </div>;
}